module.exports = __webpack_public_path__ + "img/icon-linkedin.95056188.svg";